import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShowcaseBlocksReordered.meta';

export type UseTrackShowcaseBlocksReorderedParams = {
  page_name: string;
};

export const useTrackShowcaseBlocksReordered = () => {
  const { track } = useAnalyticsUtilities();

  const trackShowcaseBlocksReordered = useCallback(
    (params: UseTrackShowcaseBlocksReorderedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackShowcaseBlocksReordered };
};
